import { dayjs } from '@2wunder/klarx-tool'
import { Col, Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KDatePicker from 'app/components/Modules/Form/KDatePicker'
import KFormList from 'app/components/Modules/Form/KFormList'
import KInputText from 'app/components/Modules/Form/KInputText'
import KTextArea from 'app/components/Modules/Form/KTextArea'
import { useKFormContext } from 'app/lib/contexts/KFormContext'
import * as React from 'react'
import { useEffect } from 'react'

import { getMaxCheckupDays } from '../LineItem/helpers'
interface Props {
  line_items: ILineItem[]
}

const MIN_CHECKUP_HOURS_FOR_SAME_DAY = 1 // hours

const BulkForm: React.FC<MemberProps<ILineItem, Props>> = ({
  props: { line_items } = { line_items: [] }
}) => {
  const { form } = useKFormContext()

  const maxCheckupDay = getMaxCheckupDays(line_items)
  const checkupHours = maxCheckupDay === 0 ? MIN_CHECKUP_HOURS_FOR_SAME_DAY : 0
  const minDate = dayjs().add(maxCheckupDay, 'day').add(checkupHours, 'hours').minute(0)
  const maxDate = dayjs.min(line_items.map((line_item) => dayjs(line_item.returnDate)))

  useEffect(() => {
    // reset default vacant date on selected line items change
    form.setFieldsValue({
      vacantDate: minDate.toLocaleDateTime()
    })
  }, [minDate.toLocaleDateTime()])

  return (
    <Row>
      <Col span={24}>
        <KFormList name="lineItemIds">
          {() =>
            line_items.map((line_item, index) => (
              <KInputText
                hidden
                key={line_item.id}
                initialValue={line_item.id.toString()}
                name={[index]}
              />
            ))
          }
        </KFormList>
        <KDatePicker
          labelRenderer={(label) => <span className="font-weight-bold">{label}</span>}
          minDate={minDate.toLocaleDate()}
          maxDate={maxDate.toLocaleDate()}
          className="am-picker--small"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="vacantDate"
          timeName="vacantTime"
        />
        <KInputText
          hidden
          name="vacantTime"
          key="vacantTime"
          initialValue={minDate.format('HH:mm')}
        />
        <KTextArea
          labelRenderer={(label) => <span className="font-weight-bold">{label}</span>}
          name="vacantAnnotation"
        />
      </Col>
    </Row>
  )
}

export default BulkForm
